import React, { useState } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Image from "../../../components/Image";
const caseInfo = {
	source: "Lingzhe Wang",
};
export default function Classroom() {
	return (
		<TabPane tabId={"classroom"}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>Classroom</h4>
				</Col>
				<Col xs="12" sm={{ size: 12 }}>
					<p>
						The simulations of airborne particle spread in classroom includes
						two cases in the same environment, 1) with the teacher being the
						source of COVID-19 airborne particulates and 2) with a student in
						the middle of the classroom being the source of the airborne viral
						particles. In both cases the room is occupied with 1 teacher and 25
						students for a total occupancy of 26 and an occupancy density of 40
						ppl/1,000 sqft (25m<sup>2</sup>/person). The classroom is a standard
						HVAC setup with two ceiling air supplies and one exhaust providing a
						ventilation rate of 4 ACHs.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 1: Infected Teacher</h5>
							<figure className="figure">
								<Image src={`images/covid/classroom/teacher.gif`} alt="" />

								<figcaption className="figure-caption">
									Animation of exhaled particle velocities of an infected
									teacher at the front of a typical classroom setup. Animation
									covers 2 minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 2: Infected Student</h5>
							<figure className="figure">
								<Image src={`images/covid/classroom/student.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particle velocities of an infected
									student in the middle of typical classroom setup. Animation
									covers 2 minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs={12} sm={{ size: 12 }}>
					<p>
						In Case 1, an infected teacher, the exhaled particles from the
						teacher go up near the HVAC inlet, then are blown to the wall on the
						left.
					</p>
					<p>
						In Case 2, an infected student in the middle of the room, the
						exhaled particles rise up and fall to the second row, then circulate
						around the second row for a while. Because of the high velocity near
						the ceiling, the exhaled particles from the student spread across
						the room covering everywhere from the teacher to the fourth row.
					</p>
				</Col>
			</Row>
		</TabPane>
	);
}
